import { on } from 'delegated-events'

const adjustReadMore = (element) => {
  element.querySelectorAll('.news-content').forEach((content) => {
    const readMore = content.querySelector('.news-content-read-more.is-hidden')
    const lastP = content.querySelector('p:last-child')

    if (lastP && readMore) {
      lastP.appendChild(readMore)
      readMore.classList.remove('is-hidden')
    }
  })
}

const updatePaginationLink = (element) => {
  const link = element.querySelector('[data-paginated-list-trigger]')

  if (link) {
    const url = new URL(link.href)
    url.searchParams.set('element', element.dataset.id)
    url.pathname = '_ajax/loadnews'

    link.href = url.toString()
  }
}

document.querySelectorAll('.element-news').forEach((el) => {
  updatePaginationLink(el)
  adjustReadMore(el)
})

on('click', '.element-news [data-paginated-list-trigger]', async (e) => {
  const target = e.currentTarget
  const element = target.closest('.element-news')

  const controls = element.querySelector('[data-paginated-list-controls]')
  const list = element.querySelector('[data-paginated-list]')

  controls.classList.add('is-disabled')

  e.preventDefault()

  const res = await ajax(target.href).headers({ 'X-Requested-With': 'XMLHttpRequest' }).get().json()

  const updatedControls = document.createRange().createContextualFragment(res.pagination)
  controls.replaceWith(updatedControls)

  const updatedList = document.createRange().createContextualFragment(res.list)

  list.append(updatedList)

  updatePaginationLink(element)
  adjustReadMore(element)
})
